import {
  Component,
  OnInit,
  HostListener,
  ElementRef,
  forwardRef,
  EventEmitter,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PopoverController } from '@ionic/angular';
import { ClockInputComponent } from '../clock-input/clock-input.component';

@Component({
  selector: 'app-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TimePickerComponent),
      multi: true,
    },
  ],
})
export class TimePickerComponent implements OnInit, ControlValueAccessor {
  selectedTime: Date | null = null;
  formattedTime: string | null = null;

  private onChange: (value: any) => void = () => { };
  private onTouched: () => void = () => { };

  constructor(private elementRef: ElementRef,
    private _popoverController: PopoverController
  ) { }

  ngOnInit() { }

  async toggleTimepicker(event: Event): Promise<void> {
    const change = new EventEmitter<any>();
    const popover = await this._popoverController.create({
      component: ClockInputComponent,
      event: event,
      cssClass: 'auto-width-height-popover-component',
      componentProps: {
        selectedTime: this.selectedTime,
        change: change
      }
    });

    change.subscribe((time: any) => {
      this.onTimeChange(time);
    })
    return await popover.present();
  }

  onTimeChange(newTime: Date): void {
    // if (this.selectedTime !== newTime) {
    this.selectedTime = newTime;
    this.updateFormattedTime();
    this.onChange(this.selectedTime); // Notify parent form of the change
    // }
  }

  updateFormattedTime(): void {
    if (this.selectedTime) {
      const hours = this.selectedTime.getHours();
      const minutes = this.selectedTime.getMinutes();
      const period = hours >= 12 ? 'PM' : 'AM';
      const formattedHours = hours % 12 || 12;
      const formattedMinutes = minutes.toString().padStart(2, '0');

      this.formattedTime = `${formattedHours}:${formattedMinutes} ${period}`;
    } else {
      this.formattedTime = null;
    }
  }

  // ControlValueAccessor methods
  writeValue(value: Date | null): void {
    if (this.selectedTime !== value) {
      this.selectedTime = value;
      this.updateFormattedTime();
    }
  }

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    // this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Add logic if you want to disable the component
  }
}
